
import { Vue, Component, Emit } from 'vue-property-decorator';
import { profileEntity } from "@/models/modules/profile/entity";

@Component
export default class DropdownButton extends Vue {
	@Emit('toggle')
	toggleDropdown(): void {
	}

	get ulNameLocal(): string | undefined {
		return profileEntity.profileData?.ulName;
	}
}
